<div
  id="global-notification-container"
  class="global-notification-bottom-right"
  toastContainer></div>
